import { t } from "i18next";
import { CartInteraction } from "../enums/cartInteraction";
import { cartInteractionEvent } from "../utils/analytics/google";
import { convertArrayToObject, getMultiValueString } from "../utils/cart";
import { config } from "../utils/config";
import { redirectToURL } from "../utils/url";
import { startLoading } from "./application";
import { newCartApi } from "./newCart";
import { LineItemType } from "../enums/lineItemType";
import { updateProductHistoryOnItemDelete } from "../components/shopping-bag/ga-module";
import { logSentryTransacation } from "../utils/sentry";

const editImprint = (mainItem, cartId) => {
    const productKey: string = mainItem.productKey?.toLowerCase() ?? '';
    const variantSku: string = mainItem.variantSku?.toLowerCase() ?? '';
    const isMultiSelect: boolean = mainItem.multiSelectData?.isExist ?? false;
    const quantity: number = isMultiSelect ? (mainItem.totalQuantityWithSubItem ?? 50) : (mainItem.quantity ?? 50);
    const variantId: number = mainItem.variantId ?? '';
    const mainCustomField: any = mainItem.customfield;
    const isV2Product: boolean = mainItem.isV2Product;
    const slug: string = isV2Product ? (mainCustomField.productSlug ?? '') : (mainItem.productSlug[(config('locale'))] ?? '');
    const keyCode: string = mainCustomField.keyCodes??'';
    const alternateKeyCode: string = mainCustomField.alternateKeyCodes??'';
    const campaign: string = mainCustomField.campaignKey??'';
    const templatekey: string = mainCustomField.templateKey??'';
    const merchantProductVersion: string = mainItem.merchantProductVersion ?? '';
    const userSelection: any = mainCustomField?.userSelection ?? '';
    let selectionAttributes = '';
    let queryURL = `/${config('locale_details').current_sitename}/${t('customize.customize_Urls')}/${slug}/${productKey}?qty=${quantity}&cartid=${cartId}&lineitemid=${mainItem.id}`;

    if (isV2Product) {
        const selectionObject = convertArrayToObject(userSelection);
        selectionAttributes = encodeURIComponent(window.btoa(JSON.stringify(selectionObject)));
        if (isMultiSelect){
            const multiValueString = getMultiValueString(mainItem.productSpecification);
            queryURL += `&${multiValueString}`
        }
        queryURL += `&merchantProductVersion=${merchantProductVersion}&selectionAttributes=${selectionAttributes}`;
    } else {
        queryURL += `&variantid=${variantId}&variantSku=${variantSku}`;
    }

    if (keyCode !== '') queryURL += `&keyCode=${keyCode}`;
    if (alternateKeyCode !== '') queryURL += `&alternateKeyCode=${alternateKeyCode}`;
    if (campaign !== '') queryURL += `&campaign=${campaign}`;
    if (templatekey !== '') queryURL += `&templatekey=${templatekey}`;
    cartInteractionEvent(CartInteraction.EDIT_IMPRINT, mainItem.webCode ? mainItem.webCode : mainItem.productFamilyName);
    redirectToURL(queryURL);
}

const removeLineItem = (lineItemId, lineItemType, cart, mainItemId) => {
    return async (dispatch: any) => {
        let transaction;
        if (lineItemType === LineItemType.MAINITEM) {
            transaction = logSentryTransacation("Removing a product from Cart");
        }
        dispatch(startLoading());
        await dispatch(newCartApi.endpoints.removeItem.initiate({ cartId: cart.id, lineItemId, lineItemType, mainItemId }));
        transaction?.finish();

        switch (lineItemType) {
            case LineItemType.MAINITEM:
                updateProductHistoryOnItemDelete(cart, mainItemId, LineItemType.MAINITEM);
                break;
            case LineItemType.UPSELL:
                updateProductHistoryOnItemDelete(cart, mainItemId, LineItemType.UPSELL);
                break;
            case LineItemType.ACCESSORY:
                updateProductHistoryOnItemDelete(cart, mainItemId, LineItemType.ACCESSORY);
                break;
            default:
                break;
        }
    };
};


const cartActions = {
    editImprint,
    removeLineItem,
};

export default cartActions;